var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImagenMantenimiento(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533,
    height: 724,
    viewBox: "0 0 533 724",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.852 502.017H167.326C167.25 501.519 167.173 500.983 167.173 500.485C167.173 495.239 171.419 490.95 176.697 490.95C178.494 490.95 180.177 491.486 181.631 492.367C181.287 490.682 181.057 488.92 181.057 487.121C181.057 473.258 192.302 462 206.147 462C219.993 462 231.238 473.258 231.238 487.121C231.238 489.035 231.008 490.873 230.626 492.635C232.156 491.601 233.992 490.95 235.981 490.95C241.221 490.95 245.504 495.201 245.504 500.485C245.504 501.021 245.428 501.519 245.351 502.017H267.994C271.207 502.017 273.846 504.659 273.846 507.876C273.846 511.092 271.207 513.735 267.994 513.735H155.852C152.639 513.735 150 511.092 150 507.876C150 504.659 152.639 502.017 155.852 502.017ZM226.572 501.634C226.572 501.634 226.38 501.902 226.304 502.017H226.61C226.61 502.017 226.61 501.749 226.572 501.634Z",
    fill: "#D3EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M531.526 164.931L382.055 10.3391C376.012 4.09725 366.794 2.06769 358.686 5.20776L79.8606 113.809",
    stroke: "#666666",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M382.399 10.3393C382.399 16.045 377.771 20.6786 372.073 20.6786C366.374 20.6786 361.746 16.045 361.746 10.3393C361.746 4.63353 366.374 0 372.073 0C377.771 0 382.399 4.63353 382.399 10.3393Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1494 124.148C90.1494 129.854 85.5215 134.487 79.8226 134.487C74.1237 134.487 69.4957 129.854 69.4957 124.148C69.4957 118.442 74.1237 113.809 79.8226 113.809C85.5215 113.809 90.1494 118.442 90.1494 124.148Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M360.062 686.222L399.189 647.048L397.277 641.304L356.352 682.278L360.062 686.222Z",
    fill: "#E4E4E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M395.518 686.222L356.352 647.048L358.265 641.304L399.189 682.278L395.518 686.222Z",
    fill: "#E4E4E4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M360.062 634.985L399.189 595.772L397.277 590.067L356.352 631.041L360.062 634.985Z",
    fill: "#E4E4E4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M395.518 634.985L356.352 595.772L358.265 590.067L399.189 631.041L395.518 634.985Z",
    fill: "#E4E4E4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M360.062 583.748L399.189 544.535L397.277 538.83L356.352 579.765L360.062 583.748Z",
    fill: "#E4E4E4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M395.518 583.748L356.352 544.535L358.265 538.83L399.189 579.765L395.518 583.748Z",
    fill: "#E4E4E4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M360.062 532.473L399.189 493.299L397.277 487.555L356.352 528.529L360.062 532.473Z",
    fill: "#E4E4E4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M395.518 532.473L356.352 493.299L358.265 487.555L399.189 528.529L395.518 532.473Z",
    fill: "#E4E4E4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M360.062 481.236L399.189 442.062L397.277 436.318L356.352 477.292L360.062 481.236Z",
    fill: "#E4E4E4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M395.518 481.236L356.352 442.062L358.265 436.318L399.189 477.292L395.518 481.236Z",
    fill: "#E4E4E4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M360.062 430L399.189 390.787L397.277 385.081L356.352 426.055L360.062 430Z",
    fill: "#E4E4E4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M395.518 430L356.352 390.787L358.265 385.081L399.189 426.055L395.518 430Z",
    fill: "#E4E4E4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M394.065 178.218H400.949V694.608H394.065V178.218Z",
    fill: "#E4E4E4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M354.096 178.218H360.98V694.608H354.096V178.218Z",
    fill: "#E4E4E4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M360.062 378.763L399.189 339.55L397.277 333.844L356.352 374.818L360.062 378.763Z",
    fill: "#E4E4E4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M395.518 378.763L356.352 339.55L358.265 333.844L399.189 374.818L395.518 378.763Z",
    fill: "#E4E4E4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M360.062 327.526L399.189 288.313L397.277 282.607L356.352 323.543L360.062 327.526Z",
    fill: "#E4E4E4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M395.518 327.526L356.352 288.313L358.265 282.607L399.189 323.543L395.518 327.526Z",
    fill: "#E4E4E4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M360.062 276.25L399.189 237.076L397.277 231.332L356.352 272.306L360.062 276.25Z",
    fill: "#E4E4E4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M395.518 276.25L356.352 237.076L358.265 231.332L399.189 272.306L395.518 276.25Z",
    fill: "#E4E4E4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M360.062 225.013L399.189 185.839L397.277 180.095L356.352 221.069L360.062 225.013Z",
    fill: "#E4E4E4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M395.518 225.013L356.352 185.839L358.265 180.095L399.189 221.069L395.518 225.013Z",
    fill: "#E4E4E4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M343.768 165.62H407.718V223.329H343.768V165.62Z",
    fill: "#006DB3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M323.077 165.62H387.027V223.329H323.077V165.62Z",
    fill: "#007FD1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M349.009 665.429H412.959V723.137H349.009V665.429Z",
    fill: "#006DB3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M323.077 665.429H387.027V723.137H323.077V665.429Z",
    fill: "#007FD1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M332.333 665.429V707.399C332.333 710.998 335.24 713.908 338.835 713.908H387.027V723.137H323.077V665.429H332.295H332.333Z",
    fill: "#666666"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M443.863 162.519H504.409V204.22H443.863V162.519Z",
    fill: "#E4E4E4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M443.863 189.936H504.409V204.22H443.863V189.936Z",
    fill: "#F1F1F1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M520.894 175.577C515.021 175.577 510.261 170.81 510.261 164.931C510.261 159.052 515.021 154.285 520.894 154.285C526.766 154.285 531.526 159.052 531.526 164.931C531.526 170.81 526.766 175.577 520.894 175.577Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4036 160.642H17.2881V424.524H10.4036V160.642Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6161 408.555C6.08138 408.555 1.71661e-05 414.682 1.71661e-05 422.187V435.82H27.2705V422.187C27.2705 414.644 21.1509 408.555 13.6544 408.555H13.6161Z",
    fill: "#666666"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M513.053 161.906L473.887 122.731L468.188 124.646L509.075 165.62L513.053 161.906Z",
    fill: "#E4E4E4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M494.044 145.975L473.887 165.62L468.189 163.705L490.793 141.993L494.044 145.975Z",
    fill: "#E4E4E4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M461.84 161.906L422.713 122.731L416.975 124.646L457.9 165.62L461.84 161.906Z",
    fill: "#E4E4E4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M461.84 126.407L422.713 165.62L416.975 163.705L457.9 122.731L461.84 126.407Z",
    fill: "#E4E4E4"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M410.664 161.906L371.537 122.731L365.8 124.646L406.725 165.62L410.664 161.906Z",
    fill: "#E4E4E4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M410.664 126.407L371.537 165.62L365.8 163.705L406.725 122.731L410.664 126.407Z",
    fill: "#E4E4E4"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M359.488 161.906L320.323 122.731L314.624 124.646L355.549 165.62L359.488 161.906Z",
    fill: "#E4E4E4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M359.488 126.407L320.323 165.62L314.624 163.705L355.549 122.731L359.488 126.407Z",
    fill: "#E4E4E4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M308.312 161.906L269.147 122.731L263.448 124.646L304.373 165.62L308.312 161.906Z",
    fill: "#E4E4E4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M308.312 126.407L269.147 165.62L263.448 163.705L304.373 122.731L308.312 126.407Z",
    fill: "#E4E4E4"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M257.138 161.906L217.972 122.731L212.235 124.646L253.16 165.62L257.138 161.906Z",
    fill: "#E4E4E4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M257.138 126.407L217.972 165.62L212.235 163.705L253.16 122.731L257.138 126.407Z",
    fill: "#E4E4E4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M478.897 127.862L472.778 120.969H49.836L43.5251 127.862H478.897Z",
    fill: "#E4E4E4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M521.429 164.433C521.429 162.518 519.899 160.986 517.986 160.986H10.0967V167.879H517.986C519.899 167.879 521.429 166.347 521.429 164.433Z",
    fill: "#E4E4E4"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M205.925 161.906L166.798 122.731L161.06 124.646L201.985 165.62L205.925 161.906Z",
    fill: "#E4E4E4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M205.925 126.407L166.798 165.62L161.06 163.705L201.985 122.731L205.925 126.407Z",
    fill: "#E4E4E4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M154.749 161.906L115.622 122.731L109.885 124.646L150.81 165.62L154.749 161.906Z",
    fill: "#E4E4E4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M154.749 126.407L115.622 165.62L109.885 163.705L150.81 122.731L154.749 126.407Z",
    fill: "#E4E4E4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M103.574 161.906L64.4087 122.731L58.7098 124.646L99.6347 165.62L103.574 161.906Z",
    fill: "#E4E4E4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M103.574 126.408L64.4087 165.62L58.7098 163.706L99.6347 122.731L103.574 126.408Z",
    fill: "#E4E4E4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3994 161.906L31.9752 141.725L27.7297 144.788L48.4599 165.62L52.3994 161.906Z",
    fill: "#E4E4E4"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3994 126.407L13.2339 165.62L10.2888 161.331L48.4599 122.731L52.3994 126.407Z",
    fill: "#E4E4E4"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M323.535 173.777H377.312V215.555H323.535V173.777Z",
    fill: "#49B8FF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M350.424 191.085H333.595C330.114 191.085 327.284 188.252 327.284 184.767C327.284 181.282 330.114 178.448 333.595 178.448H350.424C353.904 178.448 356.734 181.282 356.734 184.767C356.734 188.252 353.904 191.085 350.424 191.085Z",
    fill: "#009CFF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M392.458 122.463L373.449 9.26693C373.219 7.92665 371.307 7.92665 371.078 9.26693L352.069 123.42",
    stroke: "#E4E4E4",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M384.771 76.7402H358.8",
    stroke: "#E4E4E4",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M379.607 679.022H371.384C369.204 679.022 367.406 677.223 367.406 675.04C367.406 672.857 369.204 671.057 371.384 671.057H379.607C381.787 671.057 383.585 672.857 383.585 675.04C383.585 677.223 381.787 679.022 379.607 679.022Z",
    fill: "#009CFF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M370.198 689.592H361.975C359.795 689.592 357.997 687.792 357.997 685.609C357.997 683.426 359.795 681.627 361.975 681.627H370.198C372.378 681.627 374.176 683.426 374.176 685.609C374.176 687.792 372.378 689.592 370.198 689.592Z",
    fill: "#009CFF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M394.562 711.611H399.611C401.294 711.611 402.671 710.232 402.671 708.547C402.671 706.862 401.294 705.484 399.611 705.484H394.562C392.88 705.484 391.503 706.862 391.503 708.547C391.503 710.232 392.88 711.611 394.562 711.611Z",
    fill: "#666666"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M362.97 207.628H352.452C349.927 207.628 347.862 205.56 347.862 203.033C347.862 200.505 349.927 198.438 352.452 198.438H362.97C365.494 198.438 367.56 200.505 367.56 203.033C367.56 205.56 365.494 207.628 362.97 207.628Z",
    fill: "#009CFF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M466.926 180.44H459.047C456.867 180.44 455.107 178.678 455.107 176.496C455.107 174.313 456.867 172.552 459.047 172.552H466.926C469.106 172.552 470.865 174.313 470.865 176.496C470.865 178.678 469.106 180.44 466.926 180.44Z",
    fill: "#666666"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagenMantenimiento);
export default __webpack_public_path__ + "static/media/imagen_mantenimiento.5961451afe85766e7b0f3e3c7610a580.svg";
export { ForwardRef as ReactComponent };